import { Collapse } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { INK, MOTION } from "@/theme/tokens";
import { SystemValidationTextField } from "@/ui/Inputs/SystemValidationTextField";

type Props = {
	/** A reason is picked, so the note under it applies. */
	isOpen: boolean;
	/** The picked reason is "Other": the note becomes the reason itself, and is required. */
	isOther: boolean;
	message: string;
	onMessageChange: (next: string) => void;
	testIdPrefix: string;
};

/**
 * The removal's note, revealed once a reason is picked. For "Other" it is the reason's words (P3-3): the wrapped hook
 * persists the picked label as the reason and this text as the removal message, as the desktop dialog records it.
 */
export const GapsRemovalMessageField: FC<Props> = ({ isOpen, isOther, message, onMessageChange, testIdPrefix }) => {
	const { t } = useTranslation();
	return (
		<Collapse in={isOpen} timeout={MOTION.DURATION.ENTRANCE_MD} unmountOnExit>
			<SystemValidationTextField
				value={message}
				onChange={(event) => onMessageChange(event.target.value)}
				onClear={message ? () => onMessageChange("") : undefined}
				label={isOther ? t("gaps.callIn.removal.otherLabel") : t("gaps.callIn.removal.messageLabel")}
				required={isOther}
				defaultHelperText={isOther ? t("gaps.callIn.removal.otherRequired") : undefined}
				helperTextColor={INK.MUTED}
				reserveHeightForHelperText={false}
				fullWidth
				dataTestId={`${testIdPrefix}-message`}
			/>
		</Collapse>
	);
};
